import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { type PageConfig, usePageConfig } from '@segment/contexts/page'

import ConsistentDataImage from './ConnectAndSyncImage'

const getCopy = (pageConfig: PageConfig) => ({
  heading: `Connect and sync data to 450+ destinations`,
  description: `Eliminate the need to pull manual CSV and customer pipelines. With <a href="${getAbsoluteUrl(
    `/product/reverse-etl/`,
    pageConfig
  )}" >Segment Reverse ETL</a> data teams have the ability to activate warehouse data across the scale and breadth that Segment is loved for.`,
})

export const ConnectAndSync = () => {
  const pageConfig = usePageConfig()
  const { heading, description } = getCopy(pageConfig)

  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{heading}</CopyText.Heading>
          <CopyText.Description
            tag="p"
            variant="pLarge"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(description, { allowedTags: [`a`] }),
            }}
          />
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ConsistentDataImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  justify-content: center;

  ${Section.Wrapper} {
    row-gap: 64px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 160px;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 0;
    }
  }
`

export default ConnectAndSync
